<div class="tw-grid tw-w-full tw-grid-cols-1 tw-items-start tw-gap-6 tw-p-6 tw-font-inter lg:tw-grid-cols-[minmax(0,1fr)_360px] lg:tw-gap-10">
  <section class="tw-flex tw-min-w-0 tw-w-full tw-flex-col tw-gap-8">
    <div>
      <h6 class="tw-m-0 tw-flex tw-items-center tw-gap-2 tw-text-sm tw-font-semibold tw-text-gray-900 dark:tw-text-white">
        <svg class="tw-h-[17px] tw-w-[17px] tw-shrink-0" width="17" height="17" viewBox="0 0 17 17" fill="none" aria-hidden="true">
          <g clip-path="url(#sms-config-icon)">
            <path
              d="M15 0.693359H1.66667C1.22464 0.693359 0.800716 0.872196 0.488155 1.19053C0.175595 1.50886 0 1.94061 0 2.3908V10.878C0 11.3282 0.175595 11.7599 0.488155 12.0783C0.800716 12.3966 1.22464 12.5754 1.66667 12.5754H4.62167L7.28833 15.6809C7.36655 15.7721 7.46301 15.8451 7.57124 15.8952C7.67947 15.9452 7.79696 15.9711 7.91583 15.9711C8.0347 15.9711 8.15219 15.9452 8.26042 15.8952C8.36865 15.8451 8.46512 15.7721 8.54333 15.6809L11.2117 12.5754H15C15.442 12.5754 15.8659 12.3966 16.1785 12.0783C16.4911 11.7599 16.6667 11.3282 16.6667 10.878V2.3908C16.6667 1.94061 16.4911 1.50886 16.1785 1.19053C15.8659 0.872196 15.442 0.693359 15 0.693359ZM8.33333 9.18055H4.16667C3.94565 9.18055 3.73369 9.09113 3.57741 8.93197C3.42113 8.7728 3.33333 8.55693 3.33333 8.33183C3.33333 8.10674 3.42113 7.89086 3.57741 7.7317C3.73369 7.57253 3.94565 7.48311 4.16667 7.48311H8.33333C8.55435 7.48311 8.76631 7.57253 8.92259 7.7317C9.07887 7.89086 9.16667 8.10674 9.16667 8.33183C9.16667 8.55693 9.07887 8.7728 8.92259 8.93197C8.76631 9.09113 8.55435 9.18055 8.33333 9.18055ZM12.5 5.78567H4.16667C3.94565 5.78567 3.73369 5.69626 3.57741 5.53709C3.42113 5.37792 3.33333 5.16205 3.33333 4.93696C3.33333 4.71186 3.42113 4.49599 3.57741 4.33682C3.73369 4.17765 3.94565 4.08824 4.16667 4.08824H12.5C12.721 4.08824 12.933 4.17765 13.0893 4.33682C13.2455 4.49599 13.3333 4.71186 13.3333 4.93696C13.3333 5.16205 13.2455 5.37792 13.0893 5.53709C12.933 5.69626 12.721 5.78567 12.5 5.78567Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="sms-config-icon">
              <rect width="16.6667" height="16.6667" fill="white" />
            </clipPath>
          </defs>
        </svg>
        Configure SMS messages
      </h6>
      <p class="tw-mb-0 tw-mt-1 tw-text-sm tw-leading-5 tw-text-gray-500 dark:tw-text-gray-400">
        Deliver registration confirmation to your guests instantly through international SMS.
      </p>
    </div>

    <div
      class="tw-divide-y tw-divide-gray-200 tw-overflow-hidden tw-rounded-lg tw-border tw-border-gray-200 tw-bg-white dark:tw-divide-gray-600 dark:tw-border-gray-600 dark:tw-bg-gray-800"
    >
      <label class="tw-m-0 tw-flex tw-min-h-[75px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-3 tw-px-3 tw-py-3 lg:tw-h-[75px] lg:tw-gap-4 lg:tw-px-4 lg:tw-py-0">
        <span class="tw-min-w-0">
          <span class="tw-m-0 tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-900 dark:tw-text-white">Enable for Online Registration</span>
          <span class="tw-m-0 tw-mt-0.5 tw-block tw-text-xs tw-leading-4 tw-text-gray-500 dark:tw-text-gray-400">Sent when a guest completes the online registration form.</span>
        </span>
        <span class="tw-inline-flex tw-shrink-0">
          <input
            type="checkbox"
            class="tw-peer tw-sr-only"
            role="switch"
            aria-label="Enable for Online Registration"
            [formControl]="smsControl('enable_online')"
            [attr.aria-checked]="smsControl('enable_online').value"
          />
          <span
            class="tw-flex tw-h-5 tw-w-10 tw-items-center tw-rounded-full tw-bg-gray-200 tw-px-0.5 tw-transition-colors peer-checked:tw-justify-end peer-checked:tw-bg-blue-600 dark:tw-bg-gray-600"
          >
            <span class="tw-h-4 tw-w-4 tw-rounded-full tw-bg-white tw-shadow-sm"></span>
          </span>
        </span>
      </label>
      <label class="tw-m-0 tw-flex tw-min-h-[75px] tw-cursor-pointer tw-items-center tw-justify-between tw-gap-3 tw-px-3 tw-py-3 lg:tw-h-[75px] lg:tw-gap-4 lg:tw-px-4 lg:tw-py-0">
        <span class="tw-min-w-0">
          <span class="tw-m-0 tw-block tw-text-sm tw-font-medium tw-leading-5 tw-text-gray-900 dark:tw-text-white">Enable for On-site Registration</span>
          <span class="tw-m-0 tw-mt-0.5 tw-block tw-text-xs tw-leading-4 tw-text-gray-500 dark:tw-text-gray-400">Sent when a guest is registered at the venue.</span>
        </span>
        <span class="tw-inline-flex tw-shrink-0">
          <input
            type="checkbox"
            class="tw-peer tw-sr-only"
            role="switch"
            aria-label="Enable for On-site Registration"
            [formControl]="smsControl('enable_onsite')"
            [attr.aria-checked]="smsControl('enable_onsite').value"
          />
          <span
            class="tw-flex tw-h-5 tw-w-10 tw-items-center tw-rounded-full tw-bg-gray-200 tw-px-0.5 tw-transition-colors peer-checked:tw-justify-end peer-checked:tw-bg-blue-600 dark:tw-bg-gray-600"
          >
            <span class="tw-h-4 tw-w-4 tw-rounded-full tw-bg-white tw-shadow-sm"></span>
          </span>
        </span>
      </label>
    </div>

    <app-sms-editor #smsEditor [control]="messageControl" [event]="event" [messageType]="messageType"></app-sms-editor>
  </section>

  <section class="tw-flex tw-w-full tw-flex-col tw-gap-3 lg:tw-h-[651px] lg:tw-w-[360px]">
    <p class="tw-m-0 tw-text-sm tw-font-medium tw-text-gray-900 dark:tw-text-white">Preview</p>
    <div class="tw-flex tw-min-h-[420px] tw-flex-1 tw-flex-col tw-overflow-hidden tw-rounded-[28px] tw-border-[8px] tw-border-gray-900 tw-bg-white dark:tw-border-gray-300 dark:tw-bg-gray-900">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-bg-gray-100 tw-px-4 tw-pb-3 tw-pt-[18px] dark:tw-border-gray-600 dark:tw-bg-gray-800">
        <span class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-yellow-500 tw-text-[11px] tw-font-bold tw-text-gray-900">MT</span>
        <span class="tw-text-sm tw-font-semibold tw-text-gray-900 dark:tw-text-white">MICEtribe</span>
      </div>
      <div class="tw-flex tw-min-h-0 tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-2 tw-overflow-y-auto tw-bg-white tw-px-8 tw-pb-6 tw-pt-6 dark:tw-bg-gray-900">
        <p class="tw-m-0 tw-text-center tw-text-[11px] tw-leading-4 tw-text-gray-500">Text Message · Today 10:24</p>

        <div
          class="tw-min-w-0 tw-w-full tw-max-w-full tw-whitespace-pre-wrap tw-break-words tw-rounded-xl tw-bg-gray-100 tw-p-4 tw-text-xs tw-leading-5 tw-text-gray-800 dark:tw-bg-gray-700 dark:tw-text-gray-100"
          [ngClass]="{ 'tw-text-right': smsEditor.isRtl(), 'tw-text-left': !smsEditor.isRtl() }"
          [attr.dir]="smsEditor.isRtl() ? 'rtl' : 'ltr'"
          [innerHTML]="previewHtml(smsEditor.resolvedText())"
        ></div>
      </div>
    </div>
    <p class="tw-mb-0 tw-text-center tw-text-[11px] tw-leading-4 tw-text-gray-500">Shown with sample guest. {{ sampleGuestName }} · {{ event?.name || 'Event' }}</p>
  </section>
</div>
